module.exports = __webpack_public_path__ + "img/reject.c76d8dbf.png";